import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fb-icon--blue",
  "use": "fb-icon--blue-usage",
  "viewBox": "0 0 13 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 30\" id=\"fb-icon--blue\"><path d=\"M12.202 14.8H8.431v14.856H2.717V14.8H0V9.58h2.717v-3.38C2.717 3.784 3.785 0 8.482 0l4.232.019v5.068h-3.07c-.504 0-1.213.27-1.213 1.423v3.073h4.27l-.499 5.216z\" fill=\"#003595\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol